"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var getCCGroupIds = function getCCGroupIds(networkId, networks) {
  return (0, _lodash.map)(((0, _lodash.find)(networks, {
    id: networkId
  }) || {}).coordination_centers || [], 'id');
};
var _default = exports["default"] = getCCGroupIds;